import { ChangeDetectionStrategy, Component, Input, OnDestroy, ViewChild } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';

import { Sidebar } from 'primeng/sidebar';

import { GridActions, GridService } from '@core/services';

@Component({
  selector: 'z-grid-filter',
  templateUrl: './filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterComponent implements OnDestroy {
  destroy$ = new Subject<void>();

  @Input() title: string;
  @Input() icon: string;
  @Input() styleClass: string = 'sidebar-medium';

  @ViewChild('sidebar') sidebar: Sidebar;

  constructor(private store: Store, public gridService: GridService) {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();

    if (this.sidebar?.mask) {
      this.sidebar.destroyModal();
    }
  }

  onHide(_event: any) {
    this.gridService.filtersPanel$.pipe(take(1)).subscribe((state) => {
      if (state === 'open') {
        this.store.dispatch(GridActions.closeFilterPanel());
      }
    });

    // workaround for primeng issue where mask is not destroyed
    if (this.sidebar.mask) {
      this.sidebar.destroyModal();
    }
  }
}
